export const gameFeed = {
  gameFeed: "Game Feed",
  gameFeedTitle: "Game Feed",
  gameFeedLoading: "Cargando juego...",
  gameFeedLike: "Me gusta",
  gameFeedUnlike: "Ya no me gusta",
  gameFeedLikeSingular: "me gusta",
  gameFeedLikePlural: "me gusta",
  gameFeedComments: "Comentarios",
  gameFeedNoComments: "Aún no hay comentarios. ¡Sé el primero!",
  gameFeedAddComment: "Agrega un comentario...",
  gameFeedCommentModerated:
    "Tu comentario no fue publicado porque va en contra de las políticas de la plataforma. Por favor, mantén los comentarios respetuosos.",
  gameFeedCommentSupportRedirect:
    "Para consultas sobre retiros o pagos, por favor contacta a nuestro equipo de soporte. Esta sección es solo para comentarios sobre el juego.",
  gameFeedPost: "Publicar",
  gameFeedDelete: "Eliminar",
  gameFeedLoginToComment: "Inicia sesión para comentar",
  gameFeedLoginToLike: "Inicia sesión para dar me gusta",
  gameFeedReply: "Responder",
  gameFeedReplyPlaceholder: "Escribe una respuesta...",
  gameFeedViewReplies: "Ver respuestas ({{count}})",
  gameFeedViewMoreReplies: "Ver más respuestas",
  gameFeedHideReplies: "Ocultar respuestas",
  gameFeedEndOfFeed: "¡Ya viste todos los juegos!",
  gameFeedCloseGame: "Cerrar juego",
  gameFeedExpandGame: "Expandir juego a pantalla completa",
  gameFeedDeposit: "Depositar",
  gameFeedBadgeHot: "En llamas",
  gameFeedBadgeNew: "Nuevo",
  gameFeedBadgeBigWinner: "Gran premio",
  providerProfileBack: "Volver",
  providerProfileGames: "Juegos",
  providerProfileFollowers: "Seguidores",
  providerProfileFollow: "Seguir",
  providerProfileFollowing: "Siguiendo",
  providerProfileGridView: "Vista de cuadrícula",
  providerProfileListView: "Vista de lista",
  providerProfileNoGames: "Aún no hay juegos disponibles de este proveedor.",
  providerProfileClose: "Cerrar",
  providerProfilePlayGame: "Jugar",
};
